export interface ETLDataRecalculationObj {
    definitions: string;
    dateQueued: string;
    recalcStart: string;
    recalcEnd: string;
    currentRecalculationDate: string;
    completed: boolean;
    lastModifiedDate: string;
    initiatedBy: string;
    type: string;
}

export interface ETLDataRecalculationFormattedObj {
    definitions: string;
    dateQueued: string;
    recalcStart: string;
    recalcEnd: string;
    currentRecalculationDate: string;
    completed: boolean;
    dateCompleted: string;
    recalcStartFormatted: string;
    dateQueuedFormatted: string;
    lastModifiedDateFormatted: string;
    lastModifiedDate: string;
    initiatedBy: string;
    type: string;
}

export const PERMISSION = {
    VIEW: "VIEW",
    CREATE: "CREATE"
};

export interface ETLRecalculationStatus {
    _id: string,
    dateQueued: string,
    completed: boolean,
    definitions: string,
    initiatedBy: string,
    type: string,
    currentRecalculationDate: string,
    dateCompleted: string,
    lastModifiedDate: string,
    recalcStart: string,
    recalcEnd: string
}